<app-petitioner-menu *ngIf="!isExternal"></app-petitioner-menu>
<!-- <div class="pt-2 p-4">  class removed for both attorney and petitioner looking same-->
<div>
    <router-outlet></router-outlet>
</div>
